/* eslint-disable import/prefer-default-export */
// @flow

export const QUIK_SET_CUSTOMER: 'QUIK_SET_CUSTOMER' = 'QUIK_SET_CUSTOMER';

export const QUIK_ORDER_LIST: 'QUIK_ORDER_LIST' = 'QUIK_ORDER_LIST';
export const QUIK_PENDING_ORDER_LIST: 'QUIK_PENDING_ORDER_LIST' =
  'QUIK_PENDING_ORDER_LIST';
export const QUIK_SHIPMENT_LIST: 'QUIK_SHIPMENT_LIST' = 'QUIK_SHIPMENT_LIST';
export const QUIK_OPEN_ITEMS_LIST: 'QUIK_OPEN_ITEMS_LIST' =
  'QUIK_OPEN_ITEMS_LIST';
export const QUIK_PAYMENT_LIST: 'QUIK_PAYMENT_LIST' = 'QUIK_PAYMENT_LIST';
export const QUIK_CONTACT_LIST: 'QUIK_CONTACT_LIST' = 'QUIK_CONTACT_LIST';
export const QUIK_ORDER_DETAILS: 'QUIK_ORDER_DETAILS' = 'QUIK_ORDER_DETAILS';
export const QUIK_ORDER_DETAILS_CLEAR: 'QUIK_ORDER_DETAILS_CLEAR' =
  'QUIK_ORDER_DETAILS_CLEAR';
export const QUIK_SHIPMENT_DETAILS: 'QUIK_SHIPMENT_DETAILS' =
  'QUIK_SHIPMENT_DETAILS';
export const QUIK_SHIPMENT_DETAILS_CLEAR: 'QUIK_SHIPMENT_DETAILS_CLEAR' =
  'QUIK_SHIPMENT_DETAILS_CLEAR';
export const QUIK_PAYMENT_DETAILS: 'QUIK_PAYMENT_DETAILS' =
  'QUIK_PAYMENT_DETAILS';
export const QUIK_PAYMENT_DETAILS_CLEAR: 'QUIK_PAYMENT_DETAILS_CLEAR' =
  'QUIK_PAYMENT_DETAILS_CLEAR';
export const QUIK_SET_ORDER_DETAILS_ITEMS: 'QUIK_SET_ORDER_DETAILS_ITEMS' =
  'QUIK_SET_ORDER_DETAILS_ITEMS';
export const QUIK_SET_LOCAL_CONTACT_LIST: 'QUIK_SET_LOCAL_CONTACT_LIST' =
  'QUIK_SET_LOCAL_CONTACT_LIST';
export const QUIK_SET_SHIPMENT_DETAILS: 'QUIK_SET_SHIPMENT_DETAILS' =
  'QUIK_SET_SHIPMENT_DETAILS';
